import { client } from "./client";

export function getObservableQuery(name: string) {
  const query = Array.from(client.getObservableQueries()).find(
    ([_, x]) => x.queryName === name
  );

  return query?.[1];
}
